import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

/**
 * Resend verification DTO Schema for requesting new verification emails
 */
export const ResendVerificationDtoSchema = z
    .object({
        /** User email address */
        email: z.string().email('Invalid email format').toLowerCase(),
    })
    .strict();

/**
 * Resend verification DTO for requesting new verification emails
 */
export class ResendVerificationDto extends FromSchema(ResendVerificationDtoSchema) {
    email: string;
}
